import serializable from "../common/decorators/serializable";
import { Product } from "../product/product.entity";

@serializable
export class SellUnregisterProduct extends Product {
    public readonly unregister = true;
}